// extracted by mini-css-extract-plugin
export default {"links":"Links_links__n0i83","tutorial":"Links_tutorial__-2npp","community":"Links_community__fOlme","link":"Links_link__NUrF5"};